import { render } from "./setting-msg-box.vue?vue&type=template&id=495d89c1&scoped=true&ts=true"
import script from "./setting-msg-box.vue?vue&type=script&lang=ts"
export * from "./setting-msg-box.vue?vue&type=script&lang=ts"

import "./setting-msg-box.vue?vue&type=style&index=0&id=495d89c1&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495d89c1"]])

export default __exports__